/** Minimum EGP price for a listing to remain luxury when submitted via the luxury hub. */
export const LUXURY_MIN_PRICE_EGP = 2000;

export function resolveIsLuxuryListing(requestedLuxury, priceEgp) {
  if (!requestedLuxury) return false;
  const price = Number(priceEgp);
  if (!Number.isFinite(price)) return false;
  return price >= LUXURY_MIN_PRICE_EGP;
}
